export default __webpack_public_path__ + "static/media/settings-icon.d36bd0a7.svg";